<template lang="html">
  <v-app>
    <product-model
    :allData="productItem5"
    :popular_product="randomList(popular_product, 5)"
    :header= "headerMessage"
    :hearder_description="headerDescription"
    :product_header="productHeaderMessage"
    :item_bread_crumbs="itemsBreadCrumbs"
    :isLapTopCheck="isLapTopCheck">
    </product-model>
  </v-app>
</template>

<script>
// item5
import ProductModel from '../productModel.vue'
export default {
  components: {
    ProductModel
  },
  props: [
    'popular_product',
    'productItem5',
    'randomList',
    'isLapTopCheck'
  ],
  data () {
    return {
      headerMessage: 'ชั้นรองเท้า',
      headerDescription: '666666666666666666666666666666666666666',
      productHeaderMessage: 'สินค้า',
      itemsBreadCrumbs: [
        {
          text: 'หน้าแรก',
          disabled: false,
          name: '/home'
        },
        {
          text: 'สินค้าทั้งหมด',
          disabled: false,
          name: '/product'
        },
        {
          text: 'ชั้นรองเท้า',
          disabled: true,
          name: '/product/beddings'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/categories/beddingsProduct.vue